import { render, staticRenderFns } from "./generic-message.vue?vue&type=template&id=f105604c&"
import script from "./generic-message.vue?vue&type=script&lang=js&"
export * from "./generic-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports